import s2_2_sect2_img1 from '../../../assets/images/s2_2_sect2_img1.png';
import s2_2_sect2_img2 from '../../../assets/images/s2_2_sect2_img2.png';
import s2_2_sect2_img3 from '../../../assets/images/s2_2_sect2_img3.png';
import s2_2_sect2_img4 from '../../../assets/images/s2_2_sect2_img4.png';
import s2_2_sect3_img from '../../../assets/images/s2_2_sect3_img.png';

import ProductSlider from '../common/ProductSlider';
import FixedButton from '../common/FixedButton';
import GoContact from '../common/GoContact';

export default function Content() {
  return (
    <>
      <GoContact />

      <div className="s2_1_1_sect2 pt-10">
        <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">특징</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">강력한 성능의 S100 </p>
        </div>
        <div className="center">
          <div className="col-flex gap-10 mb-5">
            <div className="row-flex-center between m-col-flex">
              <div className="s2_1_1_sect2_item w-48 m-w-100">
                <img src={s2_2_sect2_img1} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3">
                  100kg+ 고하중 용량
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  고하중 배송으로 공간 내 무거운 물건을 <br />
                  편리하게 배송 가능합니다.
                </p>
              </div>
            </div>

            <div className="row-flex-center between m-col-flex">
               <div className="s2_1_1_sect2_item w-48 m-w-100 pc-none t-none">
                <img src={s2_2_sect2_img2} alt="" />
              </div>
              <div className="s2_1_1_sect2_item w-45 txt-right">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  빠른 사용 가능
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  미리 설치된 운영 시스템과 앱을 활용하여 작동하는 S100dms{' '}
                  <br />
                  빠른 로봇 배치로 완벽한 솔루션을 제공합니다.
                </p>
              </div>
              <div className="s2_1_1_sect2_item w-48 m-w-100 m-none">
                <img src={s2_2_sect2_img2} alt="" />
              </div>
            </div>

            <div className="row-flex-center between m-col-flex">
              <div className="s2_1_1_sect2_item w-48 m-w-100">
                <img src={s2_2_sect2_img3} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  24시간 배송 <br />
                  끊임없이 서비스를 제공
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  충전 옵션 3가지 : <br />
                  충전타워, 어댑터, 그리고 15초내에 교체 가능한 배터리로 <br />
                  연중무휴 배송을 보장합니다.
                </p>
              </div>
            </div>

            <div className="row-flex-center between m-col-flex">
               <div className="s2_1_1_sect2_item w-48 m-w-100 pc-none t-none">
                <img src={s2_2_sect2_img4} alt="" />
              </div>
              <div className="s2_1_1_sect2_item w-45 txt-right">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  배송 안정성을 최대화
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  360˚ 장애물 회피, 방충 스트립 및 3개의 <br />
                  긴급 정지 버튼으로 안정성을 보장합니다.
                </p>
              </div>
              <div className="s2_1_1_sect2_item w-48 m-w-100 m-none">
                <img src={s2_2_sect2_img4} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="s2_1_1_sect3 pt-10">
        <div className="center">
      <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">제품 사양</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">
            로봇의 상세 스펙을 확인하세요
          </p>
        </div>

        <div className="flex-center mb-4">
          <img src={s2_2_sect3_img} alt="" />
        </div>

        <div className="">
          <div className="flex-center col-flex">
            <div className="s2_1_1_sect3_inner w-60 mb-5 m-w-100 t-w-100">
              <div className="row-flex-center between 
             s2_2_sect3_inner_box">
                <div className="item col-flex flex-center gap-10">
                  <p className="prt-regular fs-16 fc-a4">제품무게</p>
                  <p className="prt-bold fs-28 fc-black1">87.5kg</p>
                </div>

                <div className="item col-flex flex-center gap-10">
                  <p className="prt-regular fs-16 fc-a4">최대 운행 속도</p>
                  <p className="prt-bold fs-28 fc-black1">1 m/s</p>
                </div>

                <div className="item col-flex flex-center gap-10">
                  <p className="prt-regular fs-16 fc-a4">적재 용량</p>
                  <p className="prt-bold fs-28 fc-black1">100kg</p>
                </div>

                <div className="item col-flex flex-center gap-10">
                  <p className="prt-regular fs-16 fc-a4">최소 통로폭</p>
                  <p className="prt-bold fs-28 fc-black1">90cm</p>
                </div>
              </div>
            </div>
            <div className="s2_1_1_sect3_inner2 w-70 mb-10 m-w-100 t-w-100">
              <div className="row-flex between w-100 m-col-flex
              lh-14 s2_1_1_sect3_inner2_box">
                <div className="left w-48 m-w-100">
                  <div className="item min-h-85">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                        제품크기
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                        92.5 × 62.0 × 128.2cm <br />
                        (36.42” × 24.41” × 50.47”)
                      </p>
                    </div>
                  </div>

                  <div className="item ">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                        최대운행속도
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                        1 m/s (3.28 ft/s)
                      </p>
                    </div>
                  </div>

                  <div className="item min-h-85">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                        충전시간**
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                        2.5시간
                      </p>
                    </div>
                  </div>

                  <div className="item min-h-85">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                        제품 무게
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                        87.5kg (192.9 Ibs)
                      </p>
                    </div>
                  </div>
                </div>

                <div className="right w-48 m-w-100">
                  <div className="item min-h-85">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                        적재 용량
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                        100kg (220 Ibs+)
                      </p>
                    </div>
                  </div>

                  <div className="item ">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                        배터리 수명*
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                        최대 8시간
                      </p>
                    </div>
                  </div>

                  <div className="item min-h-85 ">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                        표준 선반 크기
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70 lh-15">
                        86.5 × 60.0 × 80.0cm <br />
                        (34.06” × 23.62“ × 31.50”)
                      </p>
                    </div>
                  </div>

                  <div className="item min-h-85">
                    <div className="row-flex w-100 between txt-left">
                      <p className="prt-semi-bold fs-20 fc-005eed w-30">
                        최소 통로 폭
                      </p>
                      <p className="prt-semi-bold fs-20 fc-black1 w-70">
                        90cm (29.53”) <br />- 회전 아님
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sub_desc prt-light fs-14 fc-888 txt-left lh-15">
                *배터리와 관련된 모든 설명은 기타 다양한 요인에 의해 제약되며,
                실제 결과는 다를 수 있습니다.
                <br />
                배터리 충전 횟수는 제한되어 결국 교체가 필요할 수 있습니다.
                배터리 수명과 충전횟수는 사용 및 설정에 따라 다릅니다.
              </div>
            </div>
          </div>
        </div>
        </div>
  
      </div>

      <ProductSlider></ProductSlider>
      <FixedButton></FixedButton>
    </>
  );
}
